import React from 'react';
import classnames from 'classnames';
import { translate } from 'Shared/translate';
import * as styles from './base.scss';
import { exit } from '../../SiteLayout/NetworkError/base.scss';
export default class NutritionFacts extends React.Component {
    constructor(props) {
        super(props);
    }
    listSubItems(parent, id) {
        !!parent.length &&
            this.rows.push(React.createElement("tr", { key: 'parent_' + id, className: classnames(styles.tableSubRow, styles.tableRow) },
                React.createElement("td", { colSpan: 2, className: classnames(styles.indent) }, translate('/Product/Nutrient/WhereOf'))));
        parent.map((data, i) => {
            this.rows.push(React.createElement("tr", { key: 'child_' + data.code + i, className: classnames(styles.tableSubRow, styles.tableRow) },
                React.createElement("td", null,
                    " - ",
                    data.displayName),
                React.createElement("td", { className: styles.right }, data.value + ' ' + data.unit)));
        });
    }
    render() {
        this.rows = [];
        this.props.tableData.map((data, i) => {
            {
                (data.value == 0 && !data.shouldAlwaysDisplay) ? exit :
                    this.rows.push(React.createElement("tr", { key: 'main_' + data.code + i, className: styles.tableRow },
                        React.createElement("td", null, data.displayName),
                        React.createElement("td", { className: styles.right }, data.value + ' ' + data.unit)));
            }
            this.listSubItems(data.children, i);
        });
        return (!!this.props.tableData &&
            this.props.tableData.length > 0 && (React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { className: styles.tableHeading },
                    React.createElement("th", null, translate('/Product/FoodValue')),
                    React.createElement("th", null,
                        translate('/Product/Value'),
                        !!this.props.nutritionInformationProvider && ' (' + this.props.nutritionInformationProvider + ')')),
                this.rows))));
    }
}
